import { render, staticRenderFns } from "./orderiklandigital-inv.vue?vue&type=template&id=0f3ef7c6"
import script from "./orderiklandigital-inv.vue?vue&type=script&lang=js"
export * from "./orderiklandigital-inv.vue?vue&type=script&lang=js"
import style0 from "./orderiklandigital-inv.vue?vue&type=style&index=0&id=0f3ef7c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports